import type { ReactNode } from "react";

export interface DetailAdditionalSectionProps {
  title: string;
  headerAction?: ReactNode;
  children: ReactNode;
}

export function DetailAdditionalSection({
  title,
  headerAction,
  children,
}: DetailAdditionalSectionProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
        {headerAction}
      </div>
      {children}
    </div>
  );
}
